import styled from 'styled-components';

export const GraphDetail = styled.div`
  position: relative;
  flex-grow: 1;
  display: flex;

  @media (min-width: 992px) {
    gap: 10px;
  }

  .graph-holder {
    width: 100%;
    display: flex;
    flex-grow: 1;
    margin: 0 0 15px;
    border-radius: 15px;
    border: ${({ $embedded }) => ($embedded ? 'none' : '1px solid #f4f4f5')};

    @media (min-width: 992px) {
      margin: 0;
    }

    .my-custom-chart{
      height: 250px;
    }
  }

`;

export const GarphInfo = styled.div`
  flex-shrink: 0;
  padding: 20px;
  border-radius: 16px;
  color: var(--primary);
  border: 1px solid rgba(157, 157, 157, 0.3);
  background: var(--white);

  @media (min-width: 992px) {
    width: 39%;
  }

  @media (min-width: 1200px) {
    width: 30%;
  }
  @media (min-width: 1440px) {
    width: 25%;
  }

  .title {
    display: block;
    font-size: 20px;
    line-height: 24px;
    margin: 0 0 10px;
  }

  .column-wrap {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  .column {
    display: flex;
    gap: 10px;
    width: 100%;
    padding: 8px;
    border-radius: 10px;
    border: 1px solid rgba(157, 157, 157, 0.2);
    background: rgba(241, 241, 241, 0.3);

    @media (min-width: 1440px) {
      padding: 10px;
    }

    .icon-box {
      flex-shrink: 0;
      width: 40px;
      height: 40px;
      border-radius: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--white);
      border: 1px solid #efefef;

      @media (min-width: 1440px) {
        width: 45px;
        height: 45px;
      }
    }

    .text-box {
      flex-grow: 1;
    }

    .subtitle {
      display: block;
      font-size: 12px;
      line-height: 15px;
      text-transform: capitalize;
      margin: 0 0 5px;
    }
    .value {
      display: block;
      font-size: 16px;
      line-height: 19px;
      font-weight: 700;
    }
  }
`;
